import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table,Button} from 'react-bootstrap';
import swal from 'sweetalert';
import moment from 'moment';
import { search } from 'react-icons-kit/icomoon/search';
import { download3 } from 'react-icons-kit/icomoon/download3';
import { cross } from 'react-icons-kit/icomoon/cross';
import {print} from 'react-icons-kit/fa/print';
import SvgIcon from 'react-icons-kit';
import ModalDetails from './modalDetails';
import Help from '../../generics/help';
import { functionalCriterial, getDateHour, htmlTemplates, unitTransferDelete, unitTransferSearch } from '../../../libs/services';

var Config = require('../../../config');

class Transfer extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.getList = this.getList.bind(this);
		this.newEntry = this.newEntry.bind(this);
		this.confirmUnit = this.confirmUnit.bind(this);
		this.openDetails = this.openDetails.bind(this);
		this.onDetele = this.onDetele.bind(this);
		this.onPrintClick = this.onPrintClick.bind(this);

		this.state = {
			start_date:"",
			end_date:"",
			status:"all",
			list:[],
			dis_auto_tras:{}
		}
	}

	async componentDidMount(){
		var response = await functionalCriterial('dis_auto_tras');
		if(response){
			this.setState({
				dis_auto_tras: response
			});
		}

		response = await getDateHour();
		if(response){
			var aux = response.split('|');
			var date = aux[0].split("/");

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
			});

			this.getList();
		}
		
	}

	async getList(){
		var response = await unitTransferSearch(
						this.state.start_date,
						this.state.end_date,
						this.state.status,
						sessionStorage.getItem('health_facilities_id'),
						this.props.waiting
					);
		if(response !== undefined){
			this.setState({list:response});
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	newEntry(e){
		e.preventDefault();
		if(this.state.dis_auto_tras.value === 'NO'){
			this.props.history.push('/unit_transfer/new');	
		}else{
			this.props.history.push('/unit_transfer/automatic');
		}
	}

	confirmUnit(e,id){
		e.preventDefault();
		this.props.history.push('/unit_transfer/confirm/'+id);
	}

	openDetails(e, id){
		e.preventDefault();
		this.modal_details.handleShow(id);
	}

	onDetele(id){
		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar el traspaso?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, async (isConfirm)=> {
	        if (isConfirm) {
				var response = await unitTransferDelete(id, this.props.waiting);
				if(response){
					swal('Buen Trabajo', 'Solicitud Eliminada','success');
					this.getList();
				}
	        }
	    });
	}

	async onPrintClick(e, id){
		e.preventDefault();

		var response = await htmlTemplates(sessionStorage.getItem("health_facilities_id"), 'AREA_DISTRIBUTION');
		if(response){
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ningún formato de impresión", 'error');
			}else{
				this.props.waiting.handleShow('Imprimiendo...');
				
				var obj ={};
				obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
				obj.id = id;
				obj.file_type = "transfer_units";
				obj.nEtiqueta = [0];

				var type = await this.props.getDocumentType(obj.file_type);

				var document;
				if(type){
					if(type.print_type === 'template'){
						document = await this.props.printDocumentTemplate(obj, type.print_automatically);
					}else if(type.print_type === 'external'){
						document = await this.props.printDocumentExternal(obj, type.print_automatically);
					}
				}

				this.props.waiting.handleClose();
				
			}
		}
		
	}

	render(){
		const {t} = this.props;
		var destiny = parseInt(sessionStorage.getItem('health_facilities_id'));

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Traspaso Unidades
					</h5>
				</div>

				<Help 
					{...this.props}
	                menu={"help_distribution"} 
	                submenu={"help_unit_transfers"}  />
	                
				<form noValidate>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Desde</span>
							<input type="date" className="form-control" name="start_date" id="start_date"
								value={this.state.start_date} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Hasta</span>
							<input type="date" className="form-control" name="end_date" id="end_date"
								value={this.state.end_date} onChange={this.handleChange} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Estatus</span>
							<select className="form-control" name="status" id="status" value={this.state.status} 
								onChange={this.handleChange}>
								<option value="all">TODOS</option>
								<option value="ENVIADA">ENVIADOS SIN CONFIRMAR</option>
								<option value="CONFIRMADA">CONFIRMADOS</option>
							</select>
						</div>
						<div className="col-xs-12 col-sm-4" style={{marginTop:'10px'}}>
							<button type="button" className="btn btn-info" onClick={this.getList} 
								style={{fontSize:"14px"}}>
								Buscar
							</button>
							<button type="button" className="btn btn-info" onClick={this.newEntry} 
								style={{fontSize:"14px", marginLeft:'10px'}}
								disabled={!this.props.task_unit_transfer.create}>
								Nuevo
							</button>
						</div>
					</div>
					<hr style={{width:'100%'}} />
					<div className="col-xs-12">
						<Table responsive hover>
							<thead>
								<tr>
									<th>Folio</th>
									<th>Enviado Por</th>
									<th>Destino</th>
									<th>No. Unidades</th>
									<th>Enviado Por</th>
									<th>Estatus</th>
									<th>Fecha y Hora</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{this.state.list.map((l, i)=>(
									<tr key={i}>
										<td>{l.folio}</td>
										<td>{l.send_by}</td>
										<td>{l.destiny}</td>
										<td>{l.tot_units}</td>
										<td>{l.shipping_user}</td>
										<td>{l.status}</td>
										<td>
											{moment(l.shipping_date).format('DD/MM/YYYY') + ' ' +
											 moment(l.shipping_time, 'H:mm:ss').format('HH:mm')}
										</td>
										<td>
											{l.destiny_id === destiny ?
												<Button className="btn btn-info btn-xs" title="Descargar" style={{marginRight:"5px"}}
													onClick={(e)=>this.confirmUnit(e, l.id)} disabled={l.status === 'CONFIRMADA'}>
													<SvgIcon icon={download3} />
												</Button>
											:null}
											{l.destiny_id !== destiny ?
												<Button className="btn btn-info btn-xs" title="Imprimir" style={{marginRight:"5px"}}
													onClick={(e)=>this.onPrintClick(e, l.id)}
													/*onClick={(e)=>this.openReport(item.unit_request.id, 'despacho', e)}*/>
													<SvgIcon icon={print} />
												</Button>
											:null}
											<Button className="btn btn-info btn-xs" title="Ver" style={{marginRight:"5px"}}
												onClick={(e)=>this.openDetails(e,l.id)} >
												<SvgIcon icon={search} />
											</Button>
											<Button className="btn btn-info btn-xs" title="Retirar" style={{marginRight:"5px"}}
												disabled={l.status !== 'ENVIADA' || !this.props.task_unit_transfer.delete}
												onClick={(e)=>this.onDetele(l.id)}>
												<SvgIcon icon={cross} />
											</Button>
												
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					</div>
				</form>

				<ModalDetails {...this.props} onRef={ref => this.modal_details = ref} />
			</div>
		)
	}

}

export default translate('translations')(Transfer);